import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ApiDocsExplorer } from "../../../components/ApiDocsExplorer";
import { DocsShell } from "../../../components/DocsShell";
import { LAYERS } from "../../../lib/api-docs-layers";
import { atlas } from "../../../lib/sdk";

/**
 * Documentacao de integracao, visao averbadora: as 4 camadas.
 *
 * Mesma area do portal do banco (`DocsShell` + conteudo de `lib/docs-content`),
 * com duas diferencas: aqui a referencia mostra todas as camadas, e o link de
 * gestao de tokens aparece — quem emite credencial e este perfil.
 */
export function AverbadoraApiDocs() {
  const { slug } = useParams<{ slug?: string }>();
  const nav = useNavigate();

  const ambientesQ = useQuery({
    queryKey: ["admin", "api-ambientes"],
    queryFn: () => atlas.admin.apiAmbientesConfig(),
    staleTime: 60_000,
  });
  const servers = ambientesQ.data
    ? [
        { key: "sandbox", label: "Homologação", url: ambientesQ.data.sandboxUrl },
        { key: "production", label: "Produção", url: ambientesQ.data.productionUrl },
      ]
    : undefined;

  return (
    <DocsShell
      titulo="Documentação da API"
      subtitulo="API separada em 4 camadas: cada token pertence a uma e só acessa o seu namespace /v1/external/<camada>/*. Use atl_test_* para homologar e atl_live_* em produção."
      slug={slug}
      onNavegar={(s) => nav(`/averbadora/api/docs/${s}`)}
      referencia={
        <ApiDocsExplorer
          layers={LAYERS}
          layerInicial="banco"
          // Só aqui: o openapi.yaml descreve as 4 camadas, então cabe na visão
          // interna. Na tela do banco parceiro ele entregaria a existência dos
          // endpoints das outras camadas.
          linkOpenapi
          linkTokens={{ href: "/averbadora/api/tokens", label: "API → Tokens" }}
          servers={servers}
        />
      }
    />
  );
}
